import {useState} from 'react';

import FriendsReportPage from '../../components/ReportComponent/FriendsReportPage';
import ContentsReportPage from '../../components/ReportComponent/ContentsReportPage';
import MainPageTitle from '../../designComponents/titles/MainPageTitle';
import {Wrapper02} from '../../designComponents/wrappers/FlexMainWrapper';

/** 신고페이지 -> 2025년 10월 managementsDashboard 페이지 안에 영역으로 대체 예정  by grimza99 pr#64*/
const Report = () => {
    const [onClickReportPageToggle, setOnClickReportPageToggle] = useState(true);
    const [onClickGatheringReportPageToggle, setOnClickGatheringReportPageToggle] = useState(false);

    const onClickReport = () => {
        setOnClickReportPageToggle(true);
        setOnClickGatheringReportPageToggle(false);
    };

    const onClickGatheringReport = () => {
        setOnClickReportPageToggle(false);
        setOnClickGatheringReportPageToggle(true);
    };

    const renderItem = [
        { text: '친구 신고', toggle: onClickReportPageToggle, onPress: onClickReport },
        { text: '게시글 신고', toggle: onClickGatheringReportPageToggle, onPress: onClickGatheringReport },
    ];
    return (
        <Wrapper02>
            <MainPageTitle rederItem={renderItem} sigle={false} />
            {onClickReportPageToggle && <FriendsReportPage />}
            {onClickGatheringReportPageToggle && <ContentsReportPage />}
        </Wrapper02>
    );
};

export default Report;
